<template>
  <div :class="['cms-container', _isMobile() ? 'mobile' : '']">
    <!-- 如果有子栏目 -->
    <div v-if="categoryInfo.subCategory">
      <a-tabs
        tab-position="left"
        :default-active-key="currentTab"
        v-model="currentTab"
        @change="handleTabChange"
      >
        <a-tab-pane
          v-for="c in categoryInfo.subCategory"
          :key="c.id"
          :tab="c.categoryName"
        >
          <a-list
            v-if="c.categoryType == 2"
            :grid="{
              gutter: _isMobile() ? 12 : 24,
              lg: 4,
              md: 3,
              sm: 2,
              xs: 1,
            }"
            item-layout="vertical"
            size="large"
            :pagination="pagination"
            :loading="loading"
            :dataSource="cmsDataSource"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-card :bordered="false" @click="toDetail(item)">
                <!-- <div class="img-zoom">
                  <img class="cover" :src="item.cmsCover_url" alt="" />
                </div> -->
                <DefaultImageBox class="cover" zoomClass :src="item.cmsCover_url"/>
                <h3 class="title">{{ item.cmsTitile }}</h3>
              </a-card>
            </a-list-item>
          </a-list>
          <a-list
            v-else
            :dataSource="cmsDataSource"
            :pagination="pagination"
            :loading="loading"
          >
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toDetail(item)"
            >
              <span class="title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- 没有子栏目 -->
    <div v-else>
      <a-list
        v-if="categoryInfo.categoryType == 2"
        :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
        item-layout="vertical"
        size="large"
        :pagination="pagination"
        :loading="loading"
        :dataSource="cmsDataSource"
      >
        <div slot="footer">共{{ info.total }}篇</div>
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" @click="toDetail(item)">
            <div class="img-zoom">
              <img class="cover" :src="item.cmsCover_url" alt="" />
            </div>
            <h3 class="title">{{ item.cmsTitile }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
      <a-list
        v-else
        item-layout="vertical"
        size="large"
        :pagination="pagination"
        :loading="loading"
        :dataSource="cmsDataSource"
      >
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta :description="item.description">
            <a slot="title" @click="toDetail(item)"
              ><h3 class="title">{{ item.cmsTitile }}</h3></a
            >
          </a-list-item-meta>
          <p v-if="item.cmsDesc">
            {{ item.cmsDesc }}
          </p>
          <div class="cms-info">
            <a-icon type="clock-circle" />
            <span class="gap"> {{ item.createTime }}</span>
          </div>
        </a-list-item>
      </a-list>
    </div>

    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentItem.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        v-if="currentItem.extraFile"
        style="width: 100%"
        controls
        oncontextmenu="return false;"
        controlsList="nodownload noremote footbar"
        autoplay
        :src="currentItem.extraFile_fileinfo[0].url"
      ></video>
    </a-modal>
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from "@/api/manage";
import "@/assets/less/animation.css";
import DefaultImageBox from "@/components/common/DefaultImageBox"
export default {
  mixins: [mixinDevice],
  components: {
    DefaultImageBox
  },
  data() {
    return {
      cmsCategoryId: "",
      categoryInfo: {},
      currentTab: "",
      info: {},
      cmsDataSource: [],
      currentItem: {},
      loading: false,
      videoVisible: false,
      pagination: {
        onChange: this.onPageChange,
        pageSize: 12,
      },
      queryParam: {
        cmsType: "",
        cmsCategoryId: "",
        pageNo: 1,
        pageSize: 12,
      },
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route(v) {
      this.init();
    },
  },
  methods: {
    init() {
      if (this.$route.query.id) {
        this.cmsCategoryId = this.$route.query.id;
      }
      if (this.$route.query.type) {
        this.queryParam.cmsType = this.$route.query.type;
      }
      if (this.cmsCategoryId) {
        this.getCmsCategory();
      } else {
        this.getCmsList();
      }
    },
    getCmsCategory() {
      this.loading = true;
      getAction("/teaching/teachingCmsCategory/getCmsCategory", {
        id: this.cmsCategoryId,
      }).then((res) => {
        if (res.success) {
          this.categoryInfo = res.result;
          if (this.categoryInfo) {
            if (this.categoryInfo.subCategory) {
              if (this.$route.query.subId) {
                this.currentTab = parseInt(this.$route.query.subId);
              } else {
                this.currentTab = this.categoryInfo.subCategory[0].id;
              }
              this.handleTabChange(this.currentTab);
            } else {
              this.queryParam.cmsCategoryId = this.categoryInfo.id;
              this.getCmsList();
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleTabChange(tab) {
      console.log(tab);
      this.queryParam.cmsCategoryId = tab;
      this.getCmsList();
    },
    onPageChange(page, pageSize) {
      this.queryParam.pageNo = page;
      this.queryParam.pageSize = pageSize;
      this.getCmsList();
    },
    getCmsList() {
      this.loading = true;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then(
        (res) => {
          if (res.success) {
            this.info = res.result;
            this.cmsDataSource = res.result.records;
            this.pagination.total = res.result.total;
          }
          this.loading = false;
        }
      );
    },
    toDetail(item) {
      console.log(item);
      if (item.cmsType == 5) {
        // 外链
        window.open(item.extraLink);
      } else if (item.cmsType == 2) {
        this.currentItem = item;
        this.videoVisible = true;
        getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id).then(
          (res) => {}
        );
      } else {
        let route = this.$router.resolve({
          path: "/cms/detail",
          query: {
            id: item.id,
          },
        });
        window.open(route.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.gap {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 14px;
}
/deep/.ant-card-body{
  padding: 0;
}
.ant-tabs .ant-tabs-left-content {
  padding-top: 8px;
}
.title {
  cursor: pointer;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  margin: 8px;
}
/deep/.title:hover {
  color: #1890ff;
}

.img-zoom {
  cursor: pointer;
  width: 100%;
  height: 170px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>